import BASE_URL from "../utils";

export function sizedUploadUrl(src, width) {
  if (!src) return "";
  const absolute = src.startsWith("http") ? src : `${BASE_URL}${src}`;
  if (!width || !absolute.includes("/uploads/")) return absolute;

  const hashIndex = absolute.indexOf("#");
  const withoutHash = hashIndex >= 0 ? absolute.slice(0, hashIndex) : absolute;
  const queryIndex = withoutHash.indexOf("?");
  const base = queryIndex >= 0 ? withoutHash.slice(0, queryIndex) : withoutHash;
  const query = queryIndex >= 0 ? withoutHash.slice(queryIndex + 1) : "";
  const encoded = base.replace(/[^/]+$/, (file) => {
    try {
      return encodeURIComponent(decodeURIComponent(file));
    } catch {
      return encodeURIComponent(file);
    }
  });
  const params = new URLSearchParams(query);
  params.set("w", String(width));
  return `${encoded}?${params.toString()}`;
}
